import React, { ReactElement } from 'react';
import * as Sentry from '@sentry/nextjs';
import Error from './Error';

class ErrorBoundary extends React.Component<
  { location: string; children: React.ReactElement },
  { hasError: boolean; location: string }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false, location: props.location };
  }

  static getDerivedStateFromError(): {
    hasError: boolean;
  } {
    return { hasError: true };
  }

  // eslint-disable-next-line
  componentDidCatch(error: any, errorInfo: any): void {
    Sentry.captureException(error, {
      extra: errorInfo,
    });
  }

  render(): ReactElement {
    if (this.state.hasError && this.state.location === this.props.location) {
      return <Error />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
